import { HOME_PAGE, navigateToPath } from '#src/utils';
import { Brands, useBrand, useTranslation } from '@edreamsodigeo/frontend-core';
import { Button } from '@edreamsodigeo/prisma-design-system';
import React from 'react';

import { PageErrorLayoutComponent } from '../PageErrorLayout';

const IMAGES: {
  [key in Brands]: string;
} = {
  ED: '/content/img/upp/errors/edreams/order_processed_edreams.svg',
  TR: '/content/img/upp/errors/travellink/order_processed_travellink.svg',
  OP: '/content/img/upp/errors/opodo/order_processed_opodo.svg',
  GO: '/content/img/upp/errors/govoyages/order_processed_govoyages.svg',
};

export const ALREADY_PROCESSED_TEST_ID = 'already-processed-component';

export const AlreadyProcessedComponent = ({
  onButtonClickCallback,
}: {
  onButtonClickCallback: () => void;
}) => {
  const { t } = useTranslation();
  const brand = useBrand();

  return (
    <PageErrorLayoutComponent
      pageErrorTitle={t('status_messages.order_success.title')}
      dataTestId={ALREADY_PROCESSED_TEST_ID}
      pageErrorMessage={t('status_messages.order_success.message')}
      pageErrorButtons={
        <>
          <Button type="primary" onClick={() => onButtonClickCallback()}>
            {t('status_messages.order_success.button.home')}
          </Button>
        </>
      }
      pageErrorImageURL={IMAGES[brand]}
      pageErrorImageAlt={'order-processed'}
    />
  );
};

export const AlreadyProcessed = () => {
  const redirectHome = () => {
    navigateToPath(HOME_PAGE);
  };

  return <AlreadyProcessedComponent onButtonClickCallback={redirectHome} />;
};
